module.exports = __webpack_public_path__ + "img/bg03.6a569164.gif";